import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-jubili-image-in-table',
  templateUrl: './jubili-image-in-table.component.html',
  styleUrls: ['./jubili-image-in-table.component.scss']
})
export class JubiliImageInTableComponent implements OnInit {

  constructor() {
  }

  @Input() src = "";
  @Input() sizeLimit = 2048000;
  @Input() showOnly = false;
  @Input() autoOfMaxSize = false;
  @Output() getFile = new EventEmitter<any>();
  @Output() isEdit = new EventEmitter<boolean>();
  @Output() maxSize = new EventEmitter<boolean>();
  File: any;
  path: any;
  private fileType  = ['image/png', 'image/jpg','image/jpeg'];

  ngOnInit(): void {
    this.isEdit.emit(false);
  }

  isImage(): boolean {
    return !(this.src == null || this.src === "")
  }

  onChange($event: any): void {
    if ($event.target.files.length === 1) {
      if(this.fileType.indexOf($event.target.files[0].type) === -1) return;
      if ($event.target.files[0].size > this.sizeLimit) {
        this.maxSize.emit(true);
        if(this.autoOfMaxSize) setTimeout(() => this.maxSize.emit(false), 5000);
        return ;
      }
      this.File = $event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.File);
      reader.onload = () => {
        this.path = reader.result;
        this.src = this.path;
      };
      this.isEdit.emit(true);
      this.getFile.emit(this.File);
    }
  }

  delete(): void {
    this.File = undefined;
    this.File = undefined;
    this.src = "";
    this.getFile.emit(undefined);
  }
}
